enum events {
  LOG_IN = "log-in",
  LOG_OUT = "log-out"
}

export default events
